import React from "react";

import { MarketplaceLaunchableCardWrapper } from "./marketplace-launchable-card";

interface AllTimePopularSectionProps {
  launchableIds: string[];
}

export function AllTimePopularSection({
  launchableIds,
}: AllTimePopularSectionProps) {
  return (
    <section>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <h2 className="text-xl font-bold text-primary">All Time Popular</h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {launchableIds.map((launchableId, index) => (
          <MarketplaceLaunchableCardWrapper
            key={launchableId}
            environment={{ environment_id: launchableId }}
            topBadge={{
              text: `#${index + 1} Popular`,
              variant: "warning",
              className: "bg-yellow-100 text-yellow-800",
            }}
          />
        ))}
      </div>
    </section>
  );
}
